import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { WINDOW } from '../tokens/window';

const AUTHORIZATION_TOKEN_LOCAL_STORAGE_KEY = 'authorizationTokenCfgUi';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationTokenService {
  private authorizationToken: string | null;

  private authorizationTokenSubject: BehaviorSubject<string | null>;

  readonly authorizationToken$: Observable<string | null>;

  constructor(@Inject(WINDOW) private window: Window) {
    this.authorizationToken = this.window.localStorage.getItem(AUTHORIZATION_TOKEN_LOCAL_STORAGE_KEY);
    this.authorizationTokenSubject = new BehaviorSubject<string | null>(this.authorizationToken);
    this.authorizationToken$ = this.authorizationTokenSubject.asObservable();

    // In case someone logged out (or logged in as a different user) in another tab
    // authorisation token for each and every HTTP request will change
    // which is equivalent to changing user and we should react to such changes
    fromEvent<StorageEvent>(this.window, 'storage').subscribe((event) => {
      if (event.key === AUTHORIZATION_TOKEN_LOCAL_STORAGE_KEY && event.newValue !== this.authorizationToken) {
        this.authorizationToken = event.newValue;
        this.authorizationTokenSubject.next(this.authorizationToken);
      }
    });
  }

  setAuthorizationToken(authorizationToken: string | null): void {
    if (this.authorizationToken !== authorizationToken) {
      this.authorizationToken = authorizationToken;
      if (authorizationToken != null) {
        this.window.localStorage.setItem(AUTHORIZATION_TOKEN_LOCAL_STORAGE_KEY, authorizationToken);
      } else {
        this.window.localStorage.removeItem(AUTHORIZATION_TOKEN_LOCAL_STORAGE_KEY);
      }
      this.authorizationTokenSubject.next(this.authorizationToken);
    }
  }
}
